<ng-container #content>
  <!--   <div class="modal-header border-bottom-0">
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef?.hide()"> </button>
  </div> -->
  <div class="modal-body">
    <div class="text-center">
      <div class="avatar-md mx-auto">
        <div class="avatar-title bg-light rounded-circle text-primary h1">
          <i class="fas fa-bell"></i>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-xl-10">
          <h4 class="text-primary">Allow Notification !</h4>
          <h6 class="text-secondary">1. Select the lock icon in the Address bar</h6>
          <p class="text-muted font-size-14 mb-4">
            <img class="img-fluid" src="assets/images/notification/notification-guide-1.jpg" alt="notification-guide-1">
          </p>
          <h6 class="text-secondary">2. Select 'Allow' in the Notifications dropdown</h6>
          <p class="text-muted font-size-14 mb-4">
            <img class="img-fluid" src="assets/images/notification/notification-guide-2.jpg" alt="notification-guide-2">
          </p>
        </div>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="close(true)">Don't show
      again</button>
  </div>

</ng-container>